import { render, staticRenderFns } from "./ModelPermision.vue?vue&type=template&id=60bb13fd&scoped=true"
import script from "./ModelPermision.vue?vue&type=script&lang=js"
export * from "./ModelPermision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bb13fd",
  null
  
)

export default component.exports